import { useEffect, useState } from 'react';
import { useAuthState } from '@/components/context/AuthContext';

export default function useShouldShowFavouriteFilter() {
  const { user } = useAuthState();
  const [shouldShow, setShouldShow] = useState(false); // need a state that updates on mount to prevent hydration errors since the user object is different on server and client

  useEffect(() => {
    const newShouldShow = !!user;
    if (newShouldShow !== shouldShow) {
      setShouldShow(newShouldShow);
    }
  }, [user, shouldShow]);

  return shouldShow;
}
